import { stillCounts } from "./still-counts";
/**
 * Real replay frames under `public/home/stills/<root>/1..n.webp`.
 * Some coworlds prefer these curated frames to per-episode thumbnails, which
 * may remain unavailable until their render job completes. Others use them
 * only as a fallback. Coworlds without recorded imagery have no stills.
 */
export type CoverArt = {
  readonly stills: readonly string[];
  readonly first: boolean;
};
const stillsFirst: ReadonlySet<string> = new Set([
  "paintbot-pw",
  "gods-of-the-arena",
  "generals-competition",
  "paintbot-royal",
  "sugarscape-2",
]);
export function coverArtOf(coworldRoot: string): CoverArt {
  const count = stillCounts[coworldRoot] ?? 0;
  return {
    stills: Array.from(
      { length: count },
      (_, i) => `/home/stills/${coworldRoot}/${i + 1}.webp`,
    ),
    first: stillsFirst.has(coworldRoot),
  };
}
